module.exports = MaterialUI.CardActionArea;